import { render, staticRenderFns } from "./SoMeShare.vue?vue&type=template&id=7a754ad0&scoped=true&"
import script from "./SoMeShare.vue?vue&type=script&lang=js&"
export * from "./SoMeShare.vue?vue&type=script&lang=js&"
import style0 from "./SoMeShare.vue?vue&type=style&index=0&id=7a754ad0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a754ad0",
  null
  
)

export default component.exports